package com.anjuros.website.redesign.sections.contactforms

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdEyebrow
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.styles.FormsShieldStyle
import com.anjuros.website.redesign.styles.FormsSpamCopyStyle
import com.anjuros.website.redesign.styles.FormsSpamGridStyle
import com.anjuros.website.redesign.styles.FormsSpamListStyle
import com.anjuros.website.redesign.styles.FormsSpamStyle
import com.anjuros.website.redesign.styles.RdH2Style
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.util.RdIcons
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.rdList
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

/** Dark band explaining the Cloudflare Turnstile spam protection. */
@Composable
fun ContactFormsSpamSection() {
    RdSection(
        id = "spam",
        labelledBy = "spam-h",
        modifier = RdSectionStyle.toModifier().then(FormsSpamStyle.toModifier()),
        wrapModifier = FormsSpamGridStyle.toModifier(),
    ) {
        Span(FormsShieldStyle.toModifier().attrsModifier { attr("aria-hidden", "true") }.toAttrs()) { RdIcons.ShieldCheck(size = 44) }
        Div(FormsSpamCopyStyle.toModifier().toAttrs()) {
            RdEyebrow(RdText.FORMS_SPAM_EYEBROW)
            H2(RdH2Style.toModifier().id("spam-h").toAttrs()) { Text(LocalText(RdText.FORMS_SPAM_TITLE)) }
            P { Text(LocalText(RdText.FORMS_SPAM_TEXT1)) }
            P { Text(LocalText(RdText.FORMS_SPAM_TEXT2)) }
        }
        Div(FormsSpamListStyle.toModifier().toAttrs()) {
            P { Text(LocalText(RdText.FORMS_SPAM_LIST_TITLE)) }
            Ul { rdList(LocalText(RdText.FORMS_SPAM_LIST)).forEach { Li { Text(it) } } }
        }
    }
}
